import { classNames } from "@/utils/styling-utils";
import type { ReactNode } from "react";

interface InputGroupProps {
  children: ReactNode;
}

export const InputGroup = ({ children }: InputGroupProps) => (
  <div className={classNames("input-group")}>{children}</div>
);
